var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classNames,attrs:{"href":_vm.url,"target":"_blank"}},[(_vm.icon)?_c('font-awesome-icon',{staticStyle:{"margin-right":"10px"},attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }